var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',{staticClass:"justify-center text-h5"},[_vm._v(" "+_vm._s(_vm.$t("salesPartnershipUsersLabel"))+" ")]),(_vm.init)?_c('SalesPartnershipUsersTable',{attrs:{"company-id":parseInt(_vm.companyId)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }